export function isValidEmail(email: string) {
    return email.length > 5 && email.includes('@') && email.includes('.');
}
